import React from 'react';

export default {
    fields: [
        {
            type: 'text',
            name: 'permalink',
            props: {
                label: <p><i className="asterisk icon inline"/>Break URL name</p>,
                helpContent: '',
                helpHeader: '',
                required: true,
                validationRules: [
                    {
                        type: 'PermalinkFormat'
                    }
                ]
            }
        },
        {
            type: "langRadioOptions",
            name: "lang",

            props: {
                label: <p><i className="asterisk icon inline"/>Which site?</p>
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./public/components/break/copyBreakFormConfig.js